import * as React from 'react';

import type { ButtonType, ButtonFormType } from '@duel/button';
import DuelButton from '@duel/button';
import cx from 'classnames';
import type { IIconType } from '@duel/icon';
import DSXIcon from '../Icon';

export interface IButtonProps {
	id?: string;
	value?: string;
	processing?: boolean;
	style?: ButtonType;
	disabled?: boolean;
	icon?: string;
	dsxIcon?: IIconType;
	isIconAfterValue?: boolean;
	isHidden?: boolean;
	isLoading?: boolean;
	className?: string;
	onClick?: (e?) => void;
	formType?: ButtonFormType;
	name?: string;
}

export default class Button extends React.PureComponent<IButtonProps> {
	public render() {
		const {
			id,
			onClick,
			className,
			isHidden,
			icon,
			dsxIcon,
			isIconAfterValue,
			value,
			processing,
			style,
			disabled,
			children,
			name,
			isLoading,
			...others
		} = this.props;

		if (isHidden) {
			return null;
		}

		const hasValue = !!children || !!value;
		const innerValue = children || value;

		const iconClassNames = cx(`fa fa-${icon}`, hasValue ? 'mr-3' : null);

		if (dsxIcon) {
			return (
				<DuelButton
					id={id}
					processing={processing}
					// https://gitlab.directsupply.cloud/dsx/web/issues/112
					type={style as never} // TODO DSX Bug
					disabled={disabled}
					onClick={onClick}
					className={className}
					{...others}
					name={name}
				>
					{!isIconAfterValue && <DSXIcon style={dsxIcon} size="1rem" />}
					{isLoading ? (
						<DSXIcon className="text-xl md:text-4xl" style="spinner" />
					) : (
						innerValue
					)}
					{isIconAfterValue && <DSXIcon style={dsxIcon} size="1rem" />}
				</DuelButton>
			);
		}

		const iconEl = icon && <i className={iconClassNames} />;
		return (
			<DuelButton
				id={id}
				processing={processing}
				// https://gitlab.directsupply.cloud/dsx/web/issues/112
				type={style as never} // TODO DSX Bug
				disabled={disabled}
				onClick={onClick}
				className={className}
				name={name}
				{...others}
			>
				<span>
					{iconEl}
					{innerValue}
				</span>
			</DuelButton>
		);
	}
}
